import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export const FAQ = ({ items }) => {
  return (
    <Accordion type="single" collapsible className="w-full space-y-4" data-testid="faq-accordion">
      {items.map((item, index) => (
        <AccordionItem
          key={item.question}
          value={`item-${index}`}
          className="bg-white border border-[#2A2A2A]/10 rounded-sm px-6"
          data-testid={`faq-item-${index}`}
        >
          <AccordionTrigger
            className="text-left text-[#2A2A2A] font-medium hover:no-underline py-6"
            data-testid={`faq-question-${index}`}
          >
            {item.question}
          </AccordionTrigger>
          <AccordionContent
            className="text-[#737373] leading-relaxed pb-6"
            data-testid={`faq-answer-${index}`}
          >
            {item.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};